<template>
  <div
    data-qa="lpu_rating_stat"
    class="lpu-rating-stat d-flex flex-column ga-2"
  >
    <div class="d-flex justify-space-between align-center">
      <span class="text-body-2 text-secondary--text">
        {{ title }}
      </span>
      <span
        class="text-body-2"
        :class="isInactive ? 'disabled--text' : 'text--text'"
      >
        {{ formattedValue }}
      </span>
    </div>
    <div class="lpu-rating-stat__bar">
      <div
        class="lpu-rating-stat__progress"
        :class="{ 'lpu-rating-stat__progress--inactive': isInactive }"
        :style="{ width: `${progressPercent}%` }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { NO_RATING_VALUE } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/constants'
import formatRatingStatValue from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/functions/formatRatingStatValue'
import getStatProgressPercent from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/functions/getStatProgressPercent'

const props = defineProps<{
  title: string
  value: number | null
  isLargeScale?: boolean
  hasFraudMark?: boolean
}>()

const formattedValue = computed(() => formatRatingStatValue(props.value))
const progressPercent = computed(() => getStatProgressPercent(props.value, props.isLargeScale))
const isInactive = computed(() => (
  Boolean(props.hasFraudMark)
  || props.value === null
  || props.value === NO_RATING_VALUE
))
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.lpu-rating-stat {
  &__bar {
    height: 4px;
    border-radius: $border-radius-sm;
    background-color: $ui-kit-bg-gray-60;
    overflow: hidden;
  }

  &__progress {
    height: 100%;
    border-radius: $border-radius-sm;
    background-color: var(--lpu-branding-color-primary, $ui-kit-primary);

    &--inactive {
      background-color: $ui-kit-bg-gray-60;
    }
  }
}
</style>
